<template>
    <div
        :class="{ '-error': errors.has(name) }"
        @click="clickHandler"
        class="login-text-input"
    >
        <RightClickMenu
            :menuContent="menuContent"
            :disabled="inputDisabled || modal"
            :class="{ '-disabled': inputDisabled }"
            class="login-input-row"
            @click="toggleModal"
            @action="actionEmitted"
        >
            <img
                v-if="valueSpecialIcon"
                class="menu-icon"
                :src="require(`@/${valueSpecialIcon}`)"
                alt=""
            />
            <div
                :class="{
                    '-filled': value || value === 0,
                    '-error': errors.has(name)
                }"
                class="login-input-label"
            >
                {{ $t(label) }}
            </div>
            <transition name="fade" mode="out-in">
                <div class="input-loading" v-if="loading">
                    <div class="button-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <span v-else-if="valueDisplay" v-text="$t(valueDisplay)" />
                <span
                    class="-placeholder"
                    v-else-if="placeholder"
                    v-text="$t(placeholder)"
                />
                <i
                    :class="{ '-error': errors.has(name) }"
                    class="material-icons"
                    v-text="icon"
                    v-else-if="!loading && icon"
                />
            </transition>
        </RightClickMenu>
        <transition name="fade" mode="out-in">
            <div class="popup-wrap" v-if="modalVisible">
                <div class="popup-modal" @click="toggleModal" />
                <div class="popup-content -small">
                    <div
                        class="body-row"
                        v-for="option in menuContent"
                        :key="option.event.key"
                        @click="actionEmitted(option.event)"
                    >
                        <div class="row-display">
                            {{ $t(option.display) }}
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    props: {
        name: String,
        value: [String, Number],
        placeholder: String,
        loading: Boolean,
        errors: Object,
        label: String,
        options: Array,
        disabled: Boolean,
        modal: Boolean,
        icon: String
    },
    data() {
        return {
            modalVisible: false
        }
    },
    computed: {
        inputDisabled() {
            return this.disabled || this.loading
        },
        menuContent() {
            return this.options.map(option => {
                return {
                    event: {
                        name: 'selected',
                        payload: option.key
                    },
                    display: option.display,
                    specialIcon: option.icon || option.specialIcon
                }
            })
        },
        valueSpecialIcon() {
            const selectedOption = this.options.find(o => o.key == this.value)
            const optionObject = selectedOption
                ? selectedOption
                : this.options[0]
            return optionObject
                ? optionObject.icon || optionObject.specialIcon
                : ''
        },
        valueDisplay() {
            const selectedOption = this.options.find(o => o.key == this.value)
            const optionObject = selectedOption
                ? selectedOption
                : this.placeholder
                  ? this.placeholder
                  : this.options[0]
            return optionObject ? optionObject.display : ''
        }
    },
    methods: {
        toggleModal() {
            if (!this.modal) {
                return
            }
            this.modalVisible = !this.modalVisible
        },
        actionEmitted(action) {
            this.$emit('input', action.payload)
            this.toggleModal()
        },
        clickHandler() {
            this.errors.clear(this.name)
        }
    }
}
</script>
<style lang="scss" scoped>
.login-text-input {
    margin-top: 2rem;
    transition: $ease;
}
.login-input-label {
    color: $light;
    letter-spacing: 1.25px;
    font-family: $input-family;
    transition: $ease;
    position: absolute;
    pointer-events: none;
    font-size: 1rem;
    transform: translateY(-2.2rem);

    &.-error {
        color: $accent-red;
    }
}
.login-input-row {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    background: $view-background-alternative;
    border-radius: $input-radius;
    padding: 0.25rem;
    transition: $ease;
    border: solid 0.01rem transparent;

    &.-disabled {
        pointer-events: none;
    }

    &.-error {
        border-color: $accent-red;
    }
}
.input-loading {
    width: 100%;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}
.button-loader {
    margin: 0 auto;
}
.button-loader div {
    background: $action-accent;
}
span {
    flex: 1;
    border: none;
    outline: none;
    padding: 0.5rem;
    box-sizing: border-box;
    font-size: 1rem;
    letter-spacing: 1px;
    background: transparent;
    border-radius: $input-radius;
    padding-right: 2rem;
    font-family: $input-family;
    color: $input;
    transition: $ease;
    user-select: none;
    cursor: pointer;

    &.-disabled {
        cursor: default;
    }

    &.-placeholder {
        color: $input-placeholder;
    }
}
i {
    color: $light !important;
    transition: $ease;
    position: absolute;
    right: 0;

    &.-focused {
        color: $accent-blue;
    }

    &.-error {
        color: $accent-red;
    }
}
.body-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.7rem;
    user-select: none;
    transition: $ease;
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: $input-family;

    &:not(:first-of-type) {
        border-top: $list-border;
    }

    &:hover {
        background: darken($background, 2%);
    }
}
</style>
